import {FormArray, ValidationErrors, ValidatorFn} from '@angular/forms';
import {SelectableLocationMeterFormGroup} from './select-meters-for-variable-alarms.model';

export class SelectMetersForVariableAlarmValidator {
    static meterUsageAndUnitValidator(usageAndUnit: string): ValidatorFn {
        return (control): ValidationErrors | null => {
            const controls = (control as FormArray<SelectableLocationMeterFormGroup>).controls;
            const test = controls.some(
                (formGroup: SelectableLocationMeterFormGroup) =>
                    formGroup.getRawValue().usageAndUnit !== usageAndUnit &&
                    formGroup.getRawValue().select,
            );
            return !test ? null : {meterWithWrongUsageSelected: true};
        };
    }
}
